import { render, staticRenderFns } from "./InReceipt.vue?vue&type=template&id=585f9555"
import script from "./InReceipt.vue?vue&type=script&lang=js"
export * from "./InReceipt.vue?vue&type=script&lang=js"
import style0 from "./InReceipt.vue?vue&type=style&index=0&id=585f9555&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports